import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

import IconSearch from "./search.svg";

export const Container = styled(ResponsiveContainer)``;

export const StyledBaseLink = styled(BaseLink)`
  inline-size: 24px;
  block-size: 24px;
`;

export const StyledIconSearch = styled(IconSearch)`
  inline-size: 100%;
  block-size: 100%;
`;
